export const environment = {
    production: false,
    apiURL: 'https://api-dev.day1cloud.com/api',
    loginApp: 'https://login-dev.day1cloud.com',
    ping: 'https://openam-day1cloud-use1-dev.id.forgerock.io/am/',
    host: 'https://demoapp-dev.day1cloud.com',
    clientId: 'demo_app',
    oauth: {
        clientId: 'MyProfile',
        issuer: 'https://openam-dev.day1cloud.com/am/oauth2/realms/root/realms/alpha'
    }    
}